var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18453 13.6964V8.85345M11.817 13.6964V8.85345M2.80078 5.22126H17.2008M14.2383 17.3286H5.76318C5.44207 17.3286 5.13412 17.201 4.90706 16.974C4.68001 16.7469 4.55245 16.439 4.55245 16.1179V5.22126H15.449V16.1179C15.449 16.439 15.3215 16.7469 15.0944 16.974C14.8674 17.201 14.5594 17.3286 14.2383 17.3286ZM11.6625 2.7998H8.03026C7.70916 2.7998 7.4012 2.92736 7.17415 3.15442C6.94709 3.38148 6.81953 3.68943 6.81953 4.01054V5.22127H12.8732V4.01054C12.8732 3.68943 12.7456 3.38148 12.5186 3.15442C12.2915 2.92736 11.9836 2.7998 11.6625 2.7998Z",
    stroke: "#0D074B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBlue);
export default __webpack_public_path__ + "static/media/trash-blue.7119165821f795bf8fb0901a24ce8e89.svg";
export { ForwardRef as ReactComponent };